if (!Object.hasOwn) {
  Object.hasOwn = function (where, what) {
    return Object.prototype.hasOwnProperty.call(where, what);
  }
}
